import React from 'react';
import PropTypes from 'prop-types';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { IconCancel } from 'svgIcons/MotionPortalIcons';
import { translate } from 'helpers/translateHelper';

const HierarchyErrorModal = ({
    isOpen,
    onClose,
    isSaveFailed = false,
    isPartialPowertrainFailure = false,
    handleCancelUpdate
}) => {

    const handleSave = () => {
        if (isSaveFailed) {
            handleCancelUpdate();
        }
        onClose();
    };

    return (
        <GeneralDialog
            show={isOpen}
            close={onClose}
            title={
                <div className='hierarchy-error-title'>
                    <IconCancel
                        width={22}
                        height={22}
                        showCircle={true}
                        color={'rgb(241, 238, 237)'}
                        fillColor={'rgba(239, 58, 52, 1)'}
                    />
                    <span>{isSaveFailed ?
                        translate('ABB.Powertrain.Frontend.hierarchyErrorModalSaveFailed')
                        : !isPartialPowertrainFailure ?
                            translate('ABB.Powertrain.Frontend.hierarchyErrorModalTitle')
                            : translate('ABB.Powertrain.Frontend.hierarchyErrorModalPartialContent')}
                    </span>
                </div>
            }
            modalClassName='hierarchy-error-dialog'
            backdropClassName='hierarchy-error-backdrop'
            acceptButtonProps={{
                text: isSaveFailed ? translate('ABB.Powertrain.Frontend.ReloadLabel') : translate('ABB.Powertrain.Frontend.Reset'),
                onClick: handleSave
            }}
            closeButton={true}
        >
            <div className='hierarchy-error-content'>
                <p>
                    {isSaveFailed ? translate('ABB.Powertrain.Frontend.hierarchyErrorModalConcurrentEdit')
                        : translate('ABB.Powertrain.Frontend.hierarchyErrorModalContent')
                    }
                </p>
            </div>
        </GeneralDialog>
    );
};

HierarchyErrorModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default HierarchyErrorModal;
